import React, {useEffect, useState} from "react"
import {productOptionHideDisablesValues, productOptionValuesBigSize, productSizeAffectOptionIds} from "../../settings"
import {useCatalog, useSolution, useLocal} from "../../AppContext"
import {getValidOptions, getValidValues, getVariantByOptions} from "../../Hooks/Catalog"
import {MenuListOption} from "../../Components/MenuListOption"
import {Apply} from "./Apply"
import style from "./ItemOptions.css"

const APPLY_SELECTED = 1
const APPLY_TYPE = 2

export const ItemOptions = () => {
    const local = useLocal()
    const solution = useSolution()
    const catalog = useCatalog()
    const item = solution.getItem()
    const [state, setState] = useState({
        product: catalog.getParentProduct(item.parentSku),
        attributes: catalog.getParentProduct(item.parentSku).variants[item.sku].attributes,
    })
    const [apply, setApply] = useState(APPLY_SELECTED)
    const applySelected = apply === APPLY_SELECTED
    const applyType = apply === APPLY_TYPE

    const onApplySelected = () => {
        setApply(APPLY_SELECTED)
    }

    const onApplyType = () => {
        setApply(APPLY_TYPE)
    }

    const onApply = () => {
        const currentAttribute = catalog.getParentProduct(item.parentSku).variants[item.sku].attributes
        const affectSizeUpdate = !!Object.keys(state.attributes).find(optionId => productSizeAffectOptionIds.includes(parseInt(optionId)) && currentAttribute[optionId] !== state.attributes[optionId])
        const variant = getVariantByOptions(item.mountingSurfaceType, state.product, state.attributes)
        solution.itemChangeVariant(variant.sku, variant.unitCount, affectSizeUpdate, applyType)
        solution.handlerUnset()
    }

    useEffect(() => {
        setState({
            product: catalog.getParentProduct(item.parentSku),
            attributes: catalog.getParentProduct(item.parentSku).variants[item.sku].attributes,
        })
    }, [item])

    return <>
        <div>
            <MenuListOption
                label={local.__("gewählten Artikel")}
                description={local.__("Optionen nur für die ausgewählte Packeinheit anwenden")}
                isActive={applySelected}
                onClick={onApplySelected}
            />
            <MenuListOption
                label={local.__("alle Artikel dieser Art")}
                description={local.__("Optionen für alle Artikel der gleichen Art anwenden")}
                isActive={applyType}
                onClick={onApplyType}
            />
            {state.product.configurableOptions.map((option) => {
                let validValues = getValidValues(item.mountingSurfaceType, state.product, state.attributes, option.id)
                const isBig = productOptionValuesBigSize.includes(option.id)

                return <div className={style.option} key={option.id}>
                    <div className={style.header}>
                        <div className={style.label}>{option.label}</div>
                        <div className={style.value}>{option.values.find(value => value.id === state.attributes[option.id]).label}</div>
                    </div>
                    <div className={isBig ? style.valuesBig : style.valuesSmall}>
                        {option.values.map(value => {
                            const onClick = () => {
                                if (validValues.includes(value.id)) {
                                    setState({...state, attributes: getValidOptions(item.mountingSurfaceType, state.product, {...state.attributes, [option.id]: value.id})})
                                }
                            }
                            const isDisabled = !validValues.includes(value.id)
                            const isSelected = validValues.includes(value.id) && state.attributes[option.id] === value.id
                            const valueClass = isDisabled ? style.disabled : (isSelected ? style.selected : style.enabled)
                            const valueStyle = {backgroundImage: `url("${value.swatch}")`}

                            if (isDisabled && productOptionHideDisablesValues) return null

                            return <div key={value.id} onClick={onClick} title={value.label} className={valueClass}>
                                <div style={valueStyle}/>
                            </div>
                        })}
                    </div>
                    <SizeAffectOptionNote optionId={option.id}/>
                </div>
            })}
        </div>
        <Apply onClick={onApply}/>
    </>
}

const SizeAffectOptionNote = ({optionId}) => {
    const local = useLocal()
    return productSizeAffectOptionIds.includes(optionId)
        ? <div className={style.optionNote}>{local.__("Ein Änderung der Option kann unter Umständen zu einer Positionsänderung der Elemente führen.")}</div>
        : null
}